import { useEffect } from "react";
import {
  Button,
  KeyValue,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
  Tag,
} from "../../../../../components";
import { dateFormator } from "../../../../../utils";
import FinalizedEmployees from "./PayDayDetails/FinalizedEmployees";
import HoldEmployees from "./PayDayDetails/HoldEmployees";
import PaidEmployees from "./PayDayDetails/PaidEmployees";
import ProposedEmployees from "./PayDayDetails/ProposedEmployees";
import { useDispatch } from "react-redux";
import {
  clearEmpPayConfigMain,
  clearPayroll,
} from "../../../../../redux/slices/payroll/payrollSlice";
import dayjs from "dayjs";
import { exactUTCDate } from "../../../../../utils/dateFormator";
import { useLoginUser } from "../../../../../hooks/useLoginUser";

const PayDayDetails = ({
  row,
  paydayvalue,
  paycyclevalue,
  onClose,
  forceRerender,
  totalempvalue,
}) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();

  useEffect(() => {
    dispatch(clearPayroll());
    // return () => {
    //   dispatch(clearPayroll());
    // };
  }, []);
  const PayDayDetailsMenus = [
    {
      title: "Proposed Employees",
      page: <ProposedEmployees configData={row} />,
      type: "main",
    },
    {
      title: "Finalized Employees",
      page: <FinalizedEmployees configData={row} />,
      type: "main",
    },
    {
      title: "Hold Employees",
      page: <HoldEmployees configData={row} />,
      type: "main",
    },
    {
      title: "Paid Employees",
      page: <PaidEmployees configData={row} />,
      type: "main",
    },
  ];
  const fdate = () => {
    const actualPayDay = new Date(row?.payCycle?.from || null);
    const isValidDate = actualPayDay instanceof Date && !isNaN(actualPayDay);
    if (isValidDate) {
      actualPayDay.setMonth(actualPayDay.getMonth() + 1);
      actualPayDay.setDate(15);
    }

    const fromdate = row?.payCycle?.from
      ? dayjs(row?.payCycle?.from).utc().format("MM/DD/YYYY")
      : "";

    const todate = row?.payCycle?.from
      ? dayjs(row?.payCycle?.to).utc().format("MM/DD/YYYY")
      : "";

    const formatDate = fromdate && todate ? `${fromdate} to ${todate}` : "";

    return {
      // actualPayDay: isValidDate
      //   ? dateFormator(actualPayDay, "month-day-year")
      //   : "-",
      actualPayDay: row?.payDay ? exactUTCDate(row?.payDay) : "",
      formatDate,
    };
  };

  return (
    <div  className="flex flex-1 overflow-hidden flex-col">
      <PageHeader
        Section={
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-5 xl:gap-1 mt-2 items-center my-2">
            <KeyValue label={"Pay Cycle"} value={fdate().formatDate || "-"} />
            <KeyValue label={"Pay Day"} value={fdate().actualPayDay} />
            <KeyValue
              label={"Total Employees"}
              value={row?.docs?.length || 0}
            />
            <Tag
              title={loginUserData?.organizationId?.name || "-"}
              variant="outlined"
              className="!text-neutrals !py-1.5 !px-2 w-fit"
            />
          </div>
        }
        RightSection={
          <>
            <div>
              <Button
                type="button"
                title={"Back"}
                icon={"arrow_left_alt"}
                size={"sm"}
                onClick={() => {
                  onClose();
                  forceRerender();
                  dispatch(clearPayroll());
                }}
                // onClick={onClose}
              />
            </div>
          </>
        }
      />
      <div className="flex flex-1 overflow-hidden flex-col">
        <NewTab
          tabs={PayDayDetailsMenus}
          color="black"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="pay-day-details"
        />
      </div>
    </div>
  );
};

export default PayDayDetails;
